// Chakra imports
import { Box, Icon, SimpleGrid, useColorModeValue } from '@chakra-ui/react';
import InvestmentPortfolio from 'views/admin/home/components/InvestmentPortfolio';
import HistoryTransaction from 'views/admin/home/components/HistoryTransaction';
import tableDataComplex from 'views/admin/home/variables/tableDataComplex';
import MiniStatistics from 'components/card/MiniStatistics';
import IconBox from 'components/icons/IconBox';
import { MdAttachMoney } from 'react-icons/md';
import mockTransactions from './variables/tableHistoryTransactionData';
import MiniCalendar from 'components/calendar/MiniCalendar';

export default function HomePage() {
  const brandColor = useColorModeValue('brand.500', 'white');
  const boxBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.200');

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, '2xl': 6 }}
        gap="20px"
        mb="20px"
      >
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon
                  w="32px"
                  h="32px"
                  as={MdAttachMoney as any}
                  color={brandColor}
                />
              }
            />
          }
          name="Your Cost"
          value="$642.39"
        />
        <MiniStatistics growth="+23%" name="Your Balance" value="$574.34" />
      </SimpleGrid>
      <SimpleGrid columns={{ base: 1, md: 1, xl: 1 }} gap="20px" mb="20px">
        <InvestmentPortfolio tableData={tableDataComplex} />
      </SimpleGrid>
      <SimpleGrid columns={{ base: 1, md: 1, xl: 2 }} gap="20px" mb="20px">
        <HistoryTransaction tableData={mockTransactions} />{' '}
        <MiniCalendar h="100%" minW="100%" selectRange={false} />
      </SimpleGrid>
    </Box>
  );
}
